export const ET = "America/New_York";

export const localTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const viewerIsET = () => localTz() === ET;

export const fmtLocal = (utcIso, opts = {}) =>
  new Date(utcIso).toLocaleString(undefined, {
    weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short", ...opts,
  });

export const fmtDay = (utcIso) =>
  new Date(utcIso).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });

export const fmtTime = (utcIso) =>
  new Date(utcIso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit", timeZoneName: "short" });

// Local calendar day key (YYYY-MM-DD) in the viewer's zone.
export const dayKey = (d) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
};

// 6 rows × 7 cols of Date objects for the month containing `anchor`, weeks start Sunday.
export const monthMatrix = (anchor) => {
  const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
  const start = new Date(first);
  start.setDate(1 - first.getDay());
  return Array.from({ length: 42 }, (_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    return d;
  });
};

export const addMonths = (d, n) => new Date(d.getFullYear(), d.getMonth() + n, 1);
export const monthLabel = (d) => d.toLocaleDateString(undefined, { month: "long", year: "numeric" });

export const countdown = (utcIso, now = Date.now()) => {
  const ms = new Date(utcIso) - now;
  if (ms <= 0) return { live: true, label: "Recording now" };
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const mins = Math.floor((ms % 3600000) / 60000);
  const label = days > 0 ? `${days}d ${hours}h` : hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  return { live: false, days, hours, mins, label };
};

const gcalStamp = (d) => new Date(d).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

export const googleCalendarUrl = (g, homeUrl) => {
  const start = new Date(g.recording_at_utc);
  const end = new Date(start.getTime() + (g.duration_min || 60) * 60000);
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: `ATFQ · Recording with ${g.name}`,
    dates: `${gcalStamp(start)}/${gcalStamp(end)}`,
    details: `${g.public_blurb || `ATFQ records with ${g.name}`}. Send a question before we record: ${homeUrl}/#atfq-ask`,
    location: "ATFQ Podcast",
  });
  return `https://calendar.google.com/calendar/render?${p}`;
};
